/**
 * Rotating carousel of sponsors using fade in/out transitions.
 */
class Sponsors {
  constructor() {
    this.transitionClass = 'motion/animation';
    this.showClass = 'layout/block';
    this.hideClass = 'layout/none';

    this.queue = [];
    this.active = null;

    this.initialize();
  }

  initialize() {
    this.populateQueue();

    if (this.queue.length > 0) {
      const image = this.queue.pop();
      image.addEventListener('animationend', this.onTransitionEnd.bind(this));
      image.classList.add(this.transitionClass);
      image.classList.add(this.showClass);
      image.classList.remove(this.hideClass);
      this.active = image;
    }
  }

  populateQueue() {
    this.queue = Array.from(document.querySelectorAll('[data-sponsor]'));
  }

  onTransitionEnd() {
    if (this.queue.length === 0) {
      this.populateQueue();
    }

    const leaving = this.active;
    leaving.classList.remove(this.transitionClass);
    leaving.classList.remove(this.showClass);
    leaving.classList.add(this.hideClass);
    leaving.removeEventListener('animationend', this.onTransitionEnd.bind(this));

    const entering = this.queue.pop();
    if (entering) {
      entering.addEventListener('animationend', this.onTransitionEnd.bind(this));
      entering.classList.add(this.transitionClass);
      entering.classList.add(this.showClass);
      entering.classList.remove(this.hideClass);
      this.active = entering;
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new Sponsors();
});
